import React from "react";
import { stats } from "../../mock";

const StatsBar = () => {
  return (
    <section className="relative border-y border-[#00ff87]/15 bg-[#0a0a13]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-[#ffffff]/5">
          {stats.map((s, i) => (
            <div key={i} className="py-8 px-4 text-center">
              <div className="font-tech text-3xl sm:text-4xl font-bold neon-green text-glow-green">
                {s.value}
              </div>
              <div className="mt-2 text-gray-400 text-sm uppercase tracking-wide">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
